import translationService from '@services/requests/translation.service';

export let APP_TOOLTIPS = {
    COUNTRY: {
        Id: "TT100",
        Content: "Select a country. The software will propose the design method and the products range specifics to that country"
    },
    DESIGN_STANDARD: {
        Id: "TT101",
        Content: "Select a design method between one of these design standards applied in the country selected"
    },
    LANGUAGE: { Id: "TT102", Content: "Select the program language" },
    PROFILE_TYPES: { Id: "TT103", Content: "Select the profile library" },

    TOOLTIP_COMPANY_NAME: { Id: "TT217", Content: "Input company name" },
    TOOLTIP_USER_NAME: { Id: "TT218", Content: "Input user name" },
    TOOLTIP_INPUT_ADDRESS: { Id: "TT219", Content: "Input address" },
    TOOLTIP_PHONE_NUMBER: { Id: "TT220", Content: "Input phone number" },
    TOOLTIP_EMAIL_ADDRESS: { Id: "TT221", Content: "Input e-mail address" },
    TOOLTIP_FAX_NUMBER: { Id: "TT222", Content: "Input fax number" },
    TOOLTIP_WEBSITE_ADDRESS: { Id: "TT235", Content: "Input website address" },

    //General Calculation
    TOOLTIP_SQUARE: { Id: "TT104", Content: "Select a pre-determined anchor pattern for rectangular base plate" },
    TOOLTIP_CUSTOMISE_LAYOUT_SQUARE: {
        Id: "TT105",
        Content: "Click on this icon to select customize layout and enter the number of fixings as column-row matrix"
    },
    TOOLTIP_CIRCULAR_BASE_PLATE: { Id: "TT106", Content: "Select a pre-determined anchor pattern for circular base plate" },
    TOOLTIP_CUSTOMISE_LAYOUT_CIRCLE: {
        Id: "TT107",
        Content: "Click on this icon to select customize layout and enter the number of fixings arranged in a circle"
    },
    TOOLTIP_TRIANGULAR_BASE_PLATE: { Id: "TT108", Content: "Select a pre-determined anchor pattern for triangular base plate" },
    TOOLTIP_CUSTOMISE_LAYOUT_TRIANGLE: {
        Id: "TT109",
        Content: "Click on this icon to select customize layout and enter the number of fixing"
    },
    TOOLTIP_2D_EDITOR: {
        Id: "TT243",
        Content: "Design a customized anchor plate in the drawing editor"
    },

    TOOLTIP_RECTANGULAR_SHAPE: { Id: "TT224", Content: "Rectangular shape" },
    TOOLTIP_TRIANGULAR_SHAPE: { Id: "TT225", Content: "Triangular shape" },
    TOOLTIP_CIRCULAR_SHAPE: { Id: "TT226", Content: "Circular shape" },
    HEXAGON_SHAPE: { Id: "TT227", Content: "Hexagon shape" },
    OCTAGON_SHAPE: { Id: "TT228", Content: "Octagon shape" },
    TOOLTIP_CUSTOMIZABLE_LINEAR_BASE_PLATE: { Id: "TT234", Content: "Select a customizable anchor pattern for linear base plate" },
    TOOLTIP_CUSTOMIZABLE_TRIANGULAR_BASE_PLATE: { Id: "TT213", Content: "Select a customizable anchor pattern for triangular base plate" },
    TOOLTIP_CUSTOMIZABLE_RECTANGULAR_BASE_PLATE: { 
        Id: "TT214", Content: "Select a customizable anchor pattern for reactangular base plate" 
    },
    TOOLTIP_CUSTOMIZABLE_ROUNDED_EDGE_BASE_PLATE: { 
        Id: "TT215", Content: "Select a customizable anchor pattern for rounded edge base plate" 
    },
    TOOLTIP_CUSTOMIZABLE_CIRCULAR_BASE_PLATE: { 
        Id: "TT216", Content: "Select a customizable anchor pattern for circular base plate" 
    },
    TOOLTIP_BASE_PLATE_RADIUS: { Id: "TT229", Content: "Input the radius of the base plate" },
    TOOLTIP_BASE_PLATE_SIDE: { Id: "TT230", Content: "Input the side of the base plate" },
    TOOLTIP_NUMBER_OF_ANCHORS: { Id: "TT231", Content: "Input the number of anchors and the spacing between them" },
    TOOLTIP_REMOVE: { Id: "TT232", Content: "Click to remove from the positions table" },
    TOOLTIP_ADD: { Id: "TT233", Content: "Click to add in the positions table" },
    TOOLTIP_VERTICAL_POSITION: { Id: "TT212", Content: "Select this option to change the position of the anchors" },

    TOOLTIP_ROTATION_ANGLE: { Id: "TT127", Content: "Input the rotation angle of the profile" },
    TOOLTIP_NO_STAND_OFF: { Id: "TT128", Content: "No stand-off application" },
    TOOLTIP_STAND_OFF_WITHOUT_CLAMPING: { Id: "TT129", Content: "Stand-off application without clamping" },
    TOOLTIP_STAND_OFF_WITH_CLAMPING: { Id: "TT130", Content: "Stand-off application with clamping" },
    TOOLTIP_STAND_OFF_WITH_GROUT: { Id: "TT131", Content: "Stand-off application with grout" },
    TOOLTIP_INPUT_FIXINGS_EACH_ROW: { Id: "TT132", Content: "Input number of fixings in each row" },
    TOOLTIP_INPUT_FIXINGS_EACH_COLUMN: { Id: "TT133", Content: "Input number of fixings in each column" },
    TOOLTIP_INPUT_FIXINGS: { Id: "TT134", Content: "Input number of fixings" },

    //Bracket Attachment
    TOOLTIP_ANCHOR: { Id: "TT110", Content: "Select a pre-determined anchor pattern for bracket application" },
    TOOLTIP_CUSTOMISE_ANCHOR: {
        Id: "TT111",
        Content: "Click on this icon to select customize layout and enter the number of fixings as column-row matrix"
    },

    //Safety Barrier
    TOOLTIP_SAFETY_BARRIER_ANCHOR: { Id: "TT112", Content: "Select a pre-determined anchor pattern" },

    TOOLTIP_EDGE_SLAB: { Id: "TT113", Content: "Handrail fastened on edge slab" },
    TOOLTIP_SUBTYPES: { Id: "TT114", Content: "Select where the handrail shall be fastened" },

    TOOLTIP_FLOOR_SLAB: { Id: "TT115", Content: "Handrail fastened on floor slab" },
    TOOLTIP_PEDESTAL: { Id: "TT116", Content: "Handrail fastened on pedestal" },
    TOOLTIP_STAIRS: { Id: "TT117", Content: "Handrail fastened at a balustrade on stairs" },
    TOOLTIP_BETWEEN_WALLS: { Id: "TT118", Content: "Handrail fastened between walls" },

    //Rebar Reinforcement
    TOOLTIP_SLAB_TO_WALL_CONNECTION: { Id: "TT119", Content: "Slab to wall connection" },
    TOOLTIP_BEAM_CONNECTION: { Id: "TT120", Content: "Beam to wall/beam connection" },
    TOOLTIP_SLAB_EXTENSION: { Id: "TT121", Content: "Slab extension" },
    TOOLTIP_COLUMN_TO_SLAB_CONNECTION: { Id: "TT122", Content: "Wall/column to slab connection" },
    TOOLTIP_WALL_EXTENSION: { Id: "TT123", Content: "Wall extension" },
    TOOLTIP_PLATE_MATERIAL_SELECT: { Id: "TT124", Content: "Select the grade of the plate material" },
    TOOLTIP_PROFILE_FAMILY_SELECT: { Id: "TT125", Content: "Select a standard profile family" },
    TOOLTIP_PROFILE_SIZE_SELECT: { Id: "TT126", Content: "Select the dimension for the profile shape" },

    //Wood Connection
    TOOLTIP_WOOD_CONFIG_1: { Id: "TT265", Content: "Config 1" },
    TOOLTIP_WOOD_CONFIG_2: { Id: "TT263", Content: "Config 2" },
    TOOLTIP_WOOD_CONFIG_3: { Id: "TT264", Content: "Config 3" },

    //Dimensions
    //BasePlate
    TOOLTIP_BASE_PLATE_LX: { Id: "TT135", Content: "Input the width of the base plate" },
    TOOLTIP_BASE_PLATE_LY: { Id: "TT136", Content: "Input the length of the base plate " },
    TOOLTIP_SELECT_VIEW_ROTATION: { Id: "TT137", Content: "Select 3D view orientation" },
    TOOLTIP_THICKNESS_ANCHOR_PLATE: { Id: "TT138", Content: "Input the thickness of the anchor plate" },
    TOOLTIP_SPACING_BETWEEN_AMCHORS: { Id: "TT139", Content: "Input the spacing between anchors" },
    TOOLTIP_BASE_PLATE_EDGE_DISTANCE: {
        Id: "TT140",
        Content: "Input the edge distance from the anchorage point to the edge of the concrete." +
            "If distance is not entered, no concrete edge distance will taken into account."
    },
    TOOLTIP_SPACING_DISTANCE: { Id: "TT223", Content: "Input the distance" },

    //slotted holes
    TOOLTIP_NO_SLOTTED_HOLES_SPECIFIED: { Id: "TT141", Content: "No slotted holes specified" },
    TOOLTIP_SLOTTED_HOLES_SPECIFIED: {
        Id: "TT142",
        Content: "Slotted holes in the direction of the shear load may be specified when anchoring close to the slab edge."
    },

    //axis position
    TOOLTIP_AXIS_POSITION_X: { Id: "TT143", Content: "Input profile eccentricity in x-direction from base plate center" },
    TOOLTIP_AXIS_POSITION_Y: { Id: "TT144", Content: "Input profile eccentricity in y-direction from base plate center" },

    //base plate factor
    TOOLTIP_SELECT_FACTOR: { Id: "TT145", Content: "Select factor &alpha;" },

    //stand-off parameters
    TOOLTIP_STANDOFF_DISTANCE: { Id: "TT146", Content: "Input distance between base plate and concrete surface" },
    TOOLTIP_STANDOFF_RESTRAINT_LEVEL: {
        Id: "TT147",
        Content: "Input rotational restraint level  equal to 1.0 for no restraint if fixture can be freely rotate," +
            "and equal to 2.0 for full restraint if fixture cannot rotate"
    },

    TOOLTIP_STANDOFF_OPTION: {
        Id: "TT148",
        Content: "Select this option if the compressive strength of the grouting is ≥ 30 N/mm²"
    },

    TOOLTIP_CONCRETE_STRENGTH: {
        Id: "TT149",
        Content: "Select the concrete compressive strength" +
            "by selecting pre-defined value or “Custom” and input a specific compressive strength"
    },

    TOOLTIP_CONCRETE_STRENGTH_ICC: {
        Id: "TT201",
        Content: "Select the concrete compressive strength based on cylinders"
    },

    TOOLTIP_CONCRETE_STRENGTH_AS_ANZ_EU: {
        Id: "TT256",
        Content: "Select the concrete compressive strength based on 150x300 mm cylinder"
    },

    TOOLTIP_CONCRETE_STRENGTH_ANNEXC: {
        Id: "TT257",
        Content: "Select the concrete compressive strength based on 150x150 mm cubic"
    },

    TOOLTIP_CONDITIONS_OF_CONCRETE: {
        Id: "TT150",
        Content: "Select “uncracked concrete” if it is assumed no cracking will occur at service load levels"
    },

    TOOLTIP_THICKNESS_OF_CONCRETE: { Id: "TT151", Content: "Input thickness of concrete base material" },
    TOOLTIP_CONCRETE_COMPREHENSIVE_STRENGTH: {
        Id: "TT152",
        Content: "Input the value of concrete compressive strength based on 150 mm x 300 mm cylinder"
    },

    TOOLTIP_CUSTOM_CONCRETE_STRENGTH_ANNEX_C: {
        Id: "TT258",
        Content: "Input the value of concrete compressive strength based on 150 mm cube"
    },

    TOOLTIP_OPTION_LIGHTWEIGHT_CONCRETE: { Id: "TT153", Content: "Select this option for Lightweight concrete" },
    TOOLTIP_MODIFICATION_FACTOR_LAMBDA: {
        Id: "TT154",
        Content: "Input a value corresponding to the lightweight concrete modification factor &lambda;"
    },

    //Reinforcement and conditions
    TOOLTIP_REINFORCEMENT_TYPE: {
        Id: "TT155",
        Content: "Select type of concrete reinforcement." +
            "Wide reinforcement is assumed if rebar spacing is ≥ 150 mm for any diameter or ≥ 100 mm for diameter < 10 mm."
    },

    TOOLTIP_REINFORCEMENT_EDGE: {
        Id: "TT156",
        Content: "Select the type of edge reinforcement." +
            "Straight reinforcement assumes reinforced edges with straight bars with diameter ≥ 12 mm." +
            "Straight reinforcement with closely spaced stirrups assumes reinforced edges with straight bars" +
            "with diameter ≥ 12 mm and hanger reinforcement with spacing ≤ 100 mm."
    },

    TOOLTIP_REINFORCEMENT_OPTION: {
        Id: "TT157",
        Content: "Select this option if reinforcement to control splitting." +
            "Shall be checked if cracked concrete with reinforcement is present which limits the crack to width of 0.3 mm."
    },

    TOOLTIP_REINFORCEMENT_LONG_TERM_TEMPERATURE: {
        Id: "TT158",
        Content: "Input long term temperature which will be approximately constant over significant period of time."
    },

    TOOLTIP_REINFORCEMENT_SHORT_TERM_TEMPERATURE: {
        Id: "TT159",
        Content: "Input short term temperature which vary over short intervals, e.g. day/night cycles and freeze/thaw cycles."
    },

    TOOLTIP_REINFORCEMENT_INSTALLATION_CONDITIONS: {
        Id: "TT160",
        Content: "Select Hole conditions type. Shall be checked if anchors are prequalified in the conditions selected."
    },

    TOOLTIP_REINFORCEMENT_EDGE_ICC: {
        Id: "TT161",
        Content: "Select type of edge reinforcement per ACI 318-14 part 17.6.2.7, and the corresponding &psi;c,v will be applied."
    },

    TOOLTIP_REINFORCEMENT_TENSION_LOAD_ICC: {
        Id: "TT162",
        Content: "Select the tensile condition A or B and the corresponding &straightphi;" +
            " factor will be applied to the concrete breakout," +
            "pullout strength. &straightphi; factor is given in the ESR for each anchor (ACI318-14 part 17.4.3)"
    },

    TOOLTIP_REINFORCEMENT_SHEAR_LOAD_ICC: {
        Id: "TT163",
        Content: "Select the shear condition A or B and the corresponding &straightphi; factor will be applied to the pryout strength." +
            "&straightphi; factor is given in the ESR for each anchor (ACI318-14 part 17.4.3)"
    },

    //Safety Barrier Dimensions
    TOOLTIP_SAFETY_BARRIER_HEIGHT: { Id: "TT191", Content: "Input the height of safety barriers" },
    TOOLTIP_DISTANCE_BETWEEN_POSTS: { Id: "TT192", Content: "Input the distance between posts" },
    TOOLTIP_CLADDING_PROPERTIES: { Id: "TT261", Content: "Input the cladding properties" },

    //Pedestal Dimensions
    TOOLTIP_PEDESTAL_THICKNESS: { Id: "TT193", Content: "Input the thickness of the pedestal" },
    TOOLTIP_SLAB_THICKNESS: { Id: "TT194", Content: "Input the thickness of the slab" },
    TOOLTIP_PEDESTAL_WIDTH: { Id: "TT195", Content: "Input the width of the pedestal" },
    TOOLTIP_SLAB_HEIGHT: { Id: "TT196", Content: "Input the height of the finish slab" },

    //Stairs Dimensions
    TOOLTIP_STEP_HEIGHT: { Id: "TT197", Content: "Input the height of step" },
    TOOLTIP_STEP_DEPTH: {
        Id: "TT198",
        Content: "Input the depth of step." +
            "Note : the ratio between the distance between posts (Dpot) and the depth of step (Lst) must be a whole number."
    },
    TOOLTIP_STEP_STRINGER: { Id: "TT199", Content: "Input the stringer of step" },

    //Wall Dimensions
    TOOLTIP_DISTANCE_BETWEEN_WALLS: { Id: "TT200", Content: "Input the distance between wall" },

    //Loads
    //Design Loading
    TOOLTIP_DESIGN_LOADING_BUTTON: { Id: "TT164", Content: "Input values of loads at the ultimate limits, including safety factors" },
    TOOLTIP_CALCULATE_DESIGN_LOAD_BUTTON: {
        Id: "TT165",
        Content: "Input values of loads that have not yet been multiplied by the safety factors:" +
            " dead load D, live load L, temporary load A"
    },

    TOOLTIP_TENSILE_FORCE_VALUE: { Id: "TT166", Content: "Value for Tensile force" },
    TOOLTIP_SHEAR_FORCE_X_DIRECTION: { Id: "TT168", Content: "Value for Shear force in x-direction" },
    TOOLTIP_SHEAR_FORCE_Y_DIRECTION: { Id: "TT169", Content: "Value for Shear force in y-direction" },
    TOOLTIP_TORSIONAL_MOMENT_Z_AXIS: { Id: "TT170", Content: "Value for Torsional moment around z-axis" },
    TOOLTIP_BENDING_MOMENT_X_AXIS: { Id: "TT171", Content: "Value for Bending moment around x-axis" },
    TOOLTIP_BENDING_MOMENT_Y_AXIS: { Id: "TT172", Content: "Value for Bending moment around y-axis" },
    TOOLTIP_BUTTON_ADD_LOAD_COMBINATION: { Id: "TT173", Content: "Click to add a new load combination" },
    TOOLTIP_BUTTON_REMOVE_LOAD_COMBINATION: { Id: "TT174", Content: "Click to remove load combination selected" },
    TOOLTIP_BUTTON_IMPORT_COMBINATIONS:
    {
        Id: "TT259",
        Content: "Click to import combinations from CSV file or use right click button for copy-paste combinations"
    },
    TOOLTIP_IMPORT_LOADS_HEADER_NOT_REQUIRED:
    {
        Id: "TT260",
        Content: "Header field is not required. In case of headers title, " +
            "specify the following namings for headers “Nz, Vx, Vy, Mz, My, Mx”"
    },
    TOOLTIP_SELECT_LOADS_TYPE: {
        Id: "TT175",
        Content: "Select the type of loads (Standard for static and quasi-static loads, seismic load or fire load)." +
            "The design method will be selected according to the actions type entered."
    },

    TOOLTIP_DEFINE_NAME_LOAD_COMBINATION: { Id: "TT176", Content: "Double click to define the name of the load combination" },
    TOOLTIP_CHECKBOX_SUSTAINED_LOAD: {
        Id: "TT177",
        Content: "Select this option for checking the influence of sustained load on the bond strength of adhesive anchors." +
            "Input the sustained load actions to determine the ratio between the value of sustained actions and the value of total actions."
    },

    TOOLTIP_SUSTAINED_LOAD_TENSILE_FORCE: { Id: "TT178", Content: "Input sustained load value for Tensile force" },
    TOOLTIP_SUSTAINED_LOAD_BENDING_MOMENT_X: { Id: "TT179", Content: "Input the sustained load value for Bending moment around x-axis" },
    TOOLTIP_SUSTAINED_LOAD_BENDING_MOMENT_Y: { Id: "TT180", Content: "Input the sustained load value for Bending moment around y-axis" },
    TOOLTIP_SAFETY_FACTOR_DEAD_LOAD: {
        Id: "TT181",
        Content: "Input safety factor to multiply of Dead Load." +
            "This value can be defined according to National standard (Default value is 1,35)"
    },

    TOOLTIP_SAFETY_FACTOE_LIVE_LOAD: {
        Id: "TT182",
        Content: "Input safety factor to multiply of Live Load." +
            "This value can be defined according to National standard (Default value is 1.5)"
    },

    TOOLTIP_SAFETY_FACTOR_TEMPORARY_LOAD: {
        Id: "TT183",
        Content: "Input safety factor to multiply of Temporary Load" +
            "This value can be defined according to National standard (Default value is 1.75)"
    },

    //Bracket Design Loadings
    TOOLTIP_DISTANCE_L_FROM_F: { Id: "TT186", Content: "Input the distance L from application point of load F" },
    TOOLTIP_DISTANCE_LG_FROM_DEAD_WEIGHT: {
        Id: "TT187",
        Content: "Input the distance Lg from application point of dead weight of bracket"
    },

    // Rebar Loads

    TOOLTIP_REBAR_LOAD_PER_METER: { Id: "TT209", Content: "Load per meter length" },
    TOOLTIP_REBAR_LOAD_PER_SECTION: { Id: "TT210", Content: "Load per section" },
    TOOLTIP_REBAR_LOAD_PER_REBAR: { Id: "TT211", Content: "Load per rebar" },

    //Design
    TOOLTIP_DESIGN_LOADS: {
        Id: "TT167",
        Content: "Select the active load combination. If you select Decisive combination," +
            "the calculation will be done for each of load combination, and the result of the worst case will be displayed."
    },

    TOOLTIP_OPTION_SPECIFY_FIXED_DEPTH: { Id: "TT184", Content: "Select this option for specifying a fixed embedment depth" },
    TOOLTIP_INPUT_DEPTH: { Id: "TT185", Content: "Input the value of the embedment depth defined by the user." },
    TOOLTIP_F_APPLIED_AT_DISTANCE_L: { Id: "TT188", Content: "Input the vertical load F applied at distance L" },
    TOOLTIP_TENSILE_LOAD_APPLIED_IN_PROFILE_AXIS: { Id: "TT189", Content: "Input the tensile load NR applied in profile axis" },
    TOOLTIP_WEIGHT_APPLIED_AT_DISTANCE_LG: { Id: "TT190", Content: "Input the weight of the bracket applied at distance Lg" },

    // Seismic options
    TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_a:
    {
        Id: "TT202",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.4.3(a)" +
            "Option 17.2.3.4.3(a) is satisfied when the Design Steel Strength of a ductile anchor element has the highest % utilization, " +
            "and the criteria in chapters 1 and 2 are met. (Chapters 3 to 6 are under the user responsibility)"
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_b:
    {
        Id: "TT203",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.4.3(b)" +
            "Select Option 17.2.3.4.3(b) if the attachment is being designed to yield in a ductile manner." +
            " The loads must be determined for yielding of the attachment."
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_c:
    {
        Id: "TT204",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.4.3(c)" +
            "Select Option 17.2.3.4.3(c) if the anchor or group of anchors is being designed for the maximum tension that can " +
            "be transmitted to the anchors by a non-yielding attachment."
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_d:
    {
        Id: "TT205",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.4.3(d)" +
            "Select Option 17.2.3.4.3(d) if the anchor or group of anchors is being designed for the maximum tension load calculated " +
            "with the earthquake load factor E increased by the overstrength factor Ω0. The user must be entered the factored loads."
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_a:
    {
        Id: "TT206",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.5.3(a)" +
            "Select Option 17.2.3.5.3(a) if the attachment is being designed to yield in a ductile manner. " +
            "The loads must be determined for yielding of the attachment."
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_b:
    {
        Id: "TT207",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.5.3(b)" +
            "Select Option 17.2.3.5.3(b) if the anchor or group of anchors is being designed for the maximum shear that " +
            "can be transmitted to the anchors by a non-yielding attachment."
    },
    TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_c:
    {
        Id: "TT208",
        Content: "Seismic design per ACI 318-14, Option 17.2.3.5.3(c)" +
            "Select Option 17.2.3.5.3(c) if the anchor or group of anchors is being designed for the maximum shear load calculated " +
            "with the earthquake load factor E increased by the overstrength factor Ω0. The user must be entered the factored loads."
    },

    // CSA
    TOOLTIP_SEISMIC_OPTION_D4_3_5_3_a:
    {
        Id: "TT236",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.5.3 (a)" +
            "Option D4.3.5.3 (a) is satisfied when the Design Steel Strength of a ductile anchor element has the highest % utilization," +
            "and the criteria in chapters 1 and 2 are met. (Chapters 3 to 6 are under the user responsibility)"
    },
    TOOLTIP_SEISMIC_OPTION_D4_3_5_3_b:
    {
        Id: "TT237",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.5.3 (b)" +
            "Select Option D4.3.5.3 (b) if the attachment is being designed to yield in a ductile manner. " +
            "The loads must be determined for yielding of the attachment."
    },
    TOOLTIP_SEISMIC_OPTION_D4_3_5_3_c:
    {
        Id: "TT238",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.5.3 (c)" +
            "Select Option D4.3.5.3 (c) if the anchor or group of anchors is being designed for the maximum tension " +
            "that can be transmitted to the anchors by a non-yielding attachment."
    },
    TOOLTIP_SEISMIC_OPTION_D4_3_5_3_d:
    {
        Id: "TT239",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.5.3 (d)" +
            "Select Option D4.3.5.3 (d) if the anchor or group of anchors is being designed for the maximum tension " +
            "load calculated with the earthquake load factor E increased by the overstrength factor R<sub>d</sub>R<sub>0</sub>." +
            " The user must be entered the factored loads."
    },

    TOOLTIP_SEISMIC_OPTION_D4_3_6_3_a:
    {
        Id: "TT240",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.6.3 (a)" +
            "Select Option D4.3.6.3 (a) if the attachment is being designed to " +
            "yield in a ductile manner. The loads must be determined for yielding of the attachment."
    },
    TOOLTIP_SEISMIC_OPTION_D4_3_6_3_b:
    {
        Id: "TT241",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.6.3 (b)" +
            "Select Option D4.3.6.3 (b) if the anchor or group of anchors is being designed for the maximum shear " +
            "that can be transmitted to the anchors by a non-yielding attachment."
    },
    TOOLTIP_SEISMIC_OPTION_D4_3_6_3_c:
    {
        Id: "TT242",
        Content: "Seismic design per CSA A23.3-14, Option D4.3.6.3 (c)" +
        "Select Option D4.3.6.3 (c) if the anchor or group of anchors is being designed for the maximum shear load calculated with the " +
        "earthquake load factor E increased by the overstrength factor R d R 0. The user must be entered the factored loads."
    },

    // EU
    TOOLTIP_SEISMICITY_LEVEL:
    {
        Id: "TT244",
        Content: "Specify the seismicity level according to your National Annex."
    },
    TOOLTIP_SEISMIC_BUILDINGS_CLASS_1:
    {
        Id: "TT245",
        Content: "Buildings and structures that normally are not subject to human occupancy (e.g., equipment storage sheds, barns, " +
            "and other agricultural buildings) and that do not contain equipment or systems necessary " +
            "for disaster response or hazardous materials"
    },
    TOOLTIP_SEISMIC_BUILDINGS_CLASS_2:
    {
        Id: "TT246",
        Content: "Most buildings and structures of ordinary occupancy (e.g., residential, commercial, and industrial buildings) except " +
            "those buildings contained in other categories (less than 300 people, building high _ 28 m)."
    },
    TOOLTIP_SEISMIC_BUILDINGS_CLASS_3:
    {
        Id: "TT247",
        Content: "Buildings and structures that:" +
            "\r\n• Have large numbers of occupants (more than 300 people, building high _ 28 m) e.g., high-rise office buildings, " +
            "sports arenas, and large theaters." +
            "\r\n• Shelter persons with limited mobility (e.g., jails, schools, and some healthcare facilities);" +
            "\r\n• Support lifelines and utilities important to a community’s welfare;" +
            "\r\n• Contain materials that pose some risk to the public if released"
    },
    TOOLTIP_SEISMIC_BUILDINGS_CLASS_4:
    {
        Id: "TT248",
        Content: "Buildings and structures that:" +
            "\r\n• Are essential to post-earthquake response (e.g., hospitals, police stations, fire stations, and " +
            "emergency communications centers)" +
            "\r\n• House very large quantities of hazardous materials"
    },
    TOOLTIP_SEISMIC_STRUCTURAL_ELEMENTS:
    {
        Id: "TT249",
        Content: "For fixing structural elements to structures"
    },
    TOOLTIP_SEISMIC_NON_STRUCTURAL_ELEMENTS:
    {
        Id: "TT250",
        Content: "For fixing non-structural elements to structures"
    },
    TOOLTIP_SEISMIC_CATEGORY_C1:
    {
        Id: "TT251",
        Content: "The table relates the seismic performance categories C1 and C2 to the seismicity level and building importance class."
    },
    TOOLTIP_SEISMIC_CATEGORY_C2:
    {
        Id: "TT252",
        Content: "The table relates the seismic performance categories C1 and C2 to the seismicity level and building importance class."
    },
    TOOLTIP_SEISMIC_DESIGN_CAPACITY:
    {
        Id: "S1016",
        Content: "Seismic design corresponding to the yield or the maximum force that can be transferred by the attached element"
    },
    TOOLTIP_SEISMIC_DESIGN_ELASTIC:
    {
        Id: "S1015",
        Content: "Seismic design corresponding to the ultimate limit state assuming an elastic behaviour"
    },
    TOOLTIP_SEISMIC_FILLED_HOLES:
    {
        Id: "TT253",
        Content: "Filled annular gaps assume that the annular gap between anchor and anchor plate is filled with mortar. " +
            "For seismic design, filling the annular gap increase the shear design resistance (&alpha;gap = 1.0)"
    },
    TOOLTIP_SEISMIC_LIMITING_DISPLACEMENT:
    {
        Id: "TT254",
        Content: "Select this option to get the ETA displacement values for the Damage Limitation State (DLS) or modify these values."
    },
    TOOLTIP_SEISMIC_FRANCE_MAP:
    {
        Id: "TT255",
        Content: "Ouvrir la carte de France et indiquer le code postal afin de connaître le niveau de sismicité de la zone sélectionnée."
    },
    TOOLTIP_WIND_FRANCE_MAP: 
    {
        Id: "TT262",
        Content: "Open the map of France and enter the postal code to find out the wind level of the selected area."
    },

    TOOLTIP_THREADED_DIAMETER: { Id: "S901", Content: ": Threaded diameter" },
    TOOLTIP_DF_CLEARANCE_DIAMETER: { Id: "S902", Content: "df : Clearance diameter" },

    //{Id:"", Content:""}
};

export function loadTooltipss() {
    return translationService.getTranslations(Object.values(APP_TOOLTIPS).map(obj => obj.Id)).then(t => {
        if (t && t.length) {
            // var key;
            // for (key of Object.keys(APP_TOOLTIPS)) {
            Object.keys(APP_TOOLTIPS).forEach((key) => {
                let found = t.find(o => o.InternalName === APP_TOOLTIPS[key].Id);
                if (found !== undefined)
                    APP_TOOLTIPS[key].Content = found.RunName;
            });
            // }
        }
    });
}

export function getTooltip(ttId) {
    let found = Object.values(APP_TOOLTIPS).find(t => t.Id === ttId);
    if (found !== undefined)
        return found.Content;
    return "NF";
}



// WEBPACK FOOTER //
// ./src/texts/tooltips.js